import type { VignetteDefinition } from "./types";

/**
 * A common activity — a swim/dive near the shore. No dedicated swimming
 * animation exists in the sourced library; "Roll" (a tumbling motion)
 * stands in — an imperfect but visually plausible fit, framed low and
 * close to the water to sell it rather than shown head-on.
 */
export const divingVignette: VignetteDefinition = {
  id: "diving",
  name: "A dip in the water",
  category: "common",
  weight: 6,
  animationClip: "Roll",
  loopAnimation: true,
  durationMs: 4000,
  cameraFraming: {
    offset: { x: 2, y: 0.8, z: 2 },
    targetOffset: { x: 0, y: 0.3, z: 0 },
  },
  audioCues: [{ id: "sfx.splash", offsetMs: 500 }],
  timeOfDay: "day",
};
